import React from 'react'
import PropTypes from 'prop-types'
import { Filter } from 'components'
import { useFilter, useList, useLocalityModal } from 'store'
import styles from './FilterContainer.module.scss'

const FilterContainer = ({ type }) => {
  const {
    $filter,
    setFilter,
    setFieldAndScroll,
    toggleFilter,
    clearAllFiltersClick,
    goToFirstPage,
    setSelectedLocalities,
    removeSelectedLocality,
    setFieldManually,
    toggleUniqueCheckbox,
    setMaxValueRange,
    setMinValueRange,
    setCampaign,
    setCurrentBanner,
  } = useFilter()

  const { isListLoading } = useList()
  const { setClickedBy } = useLocalityModal()

  const setFieldProp = (field, value) => {
    setFieldAndScroll(field, value)
    goToFirstPage()
  }

  const toggleFilterProp = (field, value) => {
    toggleFilter(field, value)
    goToFirstPage()
  }

  return (
    <Filter
      className={styles[`wrapper-${type}`]}
      blocked={isListLoading()}
      filter={$filter}
      setFilter={setFilter}
      setClickedBy={setClickedBy}
      type={type}
      clearFilters={clearAllFiltersClick}
      setField={setFieldProp}
      toggleFilter={toggleFilterProp}
      setSelectedLocalities={setSelectedLocalities}
      removeSelectedLocality={removeSelectedLocality}
      setFieldManually={setFieldManually}
      toggleUniqueCheckbox={toggleUniqueCheckbox}
      setMaxValueRange={setMaxValueRange}
      setMinValueRange={setMinValueRange}
      setCampaign={setCampaign}
      setCurrentBanner={setCurrentBanner}
    />
  )
}

FilterContainer.propTypes = {
  type: PropTypes.string,
}

FilterContainer.defaultProps = {
  type: 'page',
}

export default FilterContainer
